// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'auth'
  }
]

export const _ = undefined
